/* -----------------Globals--------------- */
import { useAppTheme } from "@hooks/useAppTheme";
import { useTranslation } from "react-i18next";

/* -----------------Types--------------- */
import type { SectionTag, SetsAndItemsType } from "../types/tag";

import { skillIconMap } from "@constants/common";
import { formatCount } from "@memorang/helpers";
/* -----------------Child components--------------- */
import CheckboxListItem from "./CheckboxListItem";
import ListAccordion from "./ListAccordion";

interface Props {
	selectedCheckboxMap?: Record<string, boolean>;
	sectionTags: SectionTag[];
	handleSelectCheckbox: (distKey: string, locked?: boolean) => void;
	disableAll?: boolean;
	hasAccess?: boolean;
	showPremiumChip?: boolean;
	showFreeChip?: boolean;
	isDiagnostic?: boolean;
	setsAndItems: SetsAndItemsType;
}
const TagFiltersList = ({
	selectedCheckboxMap,
	handleSelectCheckbox,
	sectionTags,
	disableAll,
	hasAccess,
	showPremiumChip,
	showFreeChip,
	isDiagnostic,
	setsAndItems,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const accordions = sectionTags
		.filter((item) => item.tags.length > 0)
		.map(({ title, tags }) => {
			return {
				title,
				children: tags.map(({ id, title, locked }) => {
					const numItems = 4;

					const status = selectedCheckboxMap?.[id] ? "checked" : "unchecked";
					return (
						<CheckboxListItem
							key={id}
							title={title}
							disableAll={disableAll}
							textColor={theme.colors.text}
							status={status}
							locked={isDiagnostic ? false : !hasAccess}
							disabled={!(numItems || 0)}
							rightText={`${numItems} ${formatCount(t("common.item"), numItems)}`}
							icon={skillIconMap[title]}
							handleSelectCheckbox={() =>
								handleSelectCheckbox(String(id), locked)
							}
						/>
					);
				}),
			};
		});
	return (
		<ListAccordion
			accordions={accordions}
			disabled={disableAll}
			showPremiumChip={showPremiumChip && !hasAccess}
			showFreeChip={showFreeChip}
		/>
	);
};

export default TagFiltersList;
